var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1892",
    "data-name": "Group 1892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1887",
    "data-name": "Group 1887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_919",
    "data-name": "Path 919"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,98.08c-4.41,0-8-2.67-11.11-5a26.65,26.65,0,0,0-4.67-3,26.78,26.78,0,0,0-5.56-1.44c-3.73-.71-8-1.51-10.93-4.64s-3.63-7.33-4.32-11.42a31,31,0,0,0-1.39-6,27.86,27.86,0,0,0-2.9-5c-2.19-3.28-4.67-7-4.67-11.53s2.48-8.24,4.67-11.52a28.57,28.57,0,0,0,2.9-5,31.27,31.27,0,0,0,1.39-6c.69-4.09,1.4-8.32,4.32-11.41s7.2-3.94,10.93-4.64A26.76,26.76,0,0,0,34.22,10a25.55,25.55,0,0,0,4.67-3c3.14-2.35,6.7-5,11.11-5s8,2.66,11.12,5a25.17,25.17,0,0,0,4.66,3,26.09,26.09,0,0,0,5.57,1.45c3.73.7,8,1.5,10.92,4.64s3.63,7.33,4.32,11.42a31,31,0,0,0,1.39,6,27.55,27.55,0,0,0,2.9,5c2.19,3.29,4.67,7,4.67,11.53s-2.48,8.26-4.68,11.54a28.06,28.06,0,0,0-2.89,5,31,31,0,0,0-1.39,6c-.69,4.09-1.4,8.32-4.32,11.41s-7.19,3.94-10.93,4.65A26.78,26.78,0,0,0,65.78,90a26.65,26.65,0,0,0-4.67,3C58,95.41,54.42,98.08,50,98.08ZM50,7.93c-2.42,0-4.89,1.85-7.52,3.82a30.51,30.51,0,0,1-5.85,3.73,31.28,31.28,0,0,1-6.85,1.84c-3.12.59-6.06,1.15-7.68,2.87s-2.21,4.93-2.77,8.29a36.82,36.82,0,0,1-1.72,7.18,33.4,33.4,0,0,1-3.5,6.15c-1.88,2.82-3.66,5.49-3.66,8.19s1.78,5.38,3.66,8.2a33.08,33.08,0,0,1,3.5,6.15,36.72,36.72,0,0,1,1.72,7.17c.56,3.36,1.09,6.53,2.76,8.29s4.57,2.29,7.69,2.87a31.31,31.31,0,0,1,6.85,1.85,30.51,30.51,0,0,1,5.85,3.73c2.63,2,5.1,3.82,7.52,3.82s4.9-1.86,7.52-3.82a30.51,30.51,0,0,1,5.85-3.73,31.39,31.39,0,0,1,6.86-1.85c3.11-.58,6-1.14,7.68-2.86s2.2-4.94,2.76-8.3a36.72,36.72,0,0,1,1.72-7.17,33.52,33.52,0,0,1,3.49-6.14c1.89-2.83,3.67-5.5,3.67-8.21s-1.78-5.37-3.66-8.19a33.4,33.4,0,0,1-3.5-6.15,36.65,36.65,0,0,1-1.72-7.18c-.56-3.35-1.09-6.52-2.76-8.29s-4.57-2.28-7.68-2.86a32,32,0,0,1-6.86-1.85,30.51,30.51,0,0,1-5.85-3.73C54.9,9.78,52.42,7.93,50,7.93Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1891",
    "data-name": "Group 1891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1890",
    "data-name": "Group 1890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_785",
    "data-name": "Line 785"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.56,63.38a3,3,0,0,1-2.18-5.05L61.93,37.62a3,3,0,1,1,4.36,4.12L46.74,62.44A3,3,0,0,1,44.56,63.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1889",
    "data-name": "Group 1889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1888",
    "data-name": "Group 1888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_786",
    "data-name": "Line 786"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.56,63.38a2.94,2.94,0,0,1-2.08-.84L31.68,52.11a3,3,0,1,1,4.16-4.31L46.65,58.23a3,3,0,0,1-2.09,5.15Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassed);
export default __webpack_public_path__ + "static/media/Passed.f00b6bf2f7ea1cf15a201b4ee86cf209.svg";
export { ForwardRef as ReactComponent };